<template>
    <div class="screen">
        <div class="screen__line">
            <img
                :src="quizBlueLine"
                alt=""
            />
        </div>
        <div class="screen__inner">
            <h3 class="screen__header heading-tertiary">{{ question }}</h3>
            <div class="screen__counter">
                <p class="screen__text heading-tertiary">
                    <span class="current-page">{{ currentPage }}</span>
                    &nbsp;<span class="total-pages"> /{{ totalPages }}</span>
                </p>
            </div>
        </div>

        <form
            class="screen__form"
            @submit.prevent="handleSubmit"
        >
            <div class="screen__form-flex">
                <div class="screen__form-column">
                    <label
                        v-for="(answer, index) in answers"
                        :key="index"
                        class="screen__label custom-checkbox"
                    >
                        <input
                            v-model="selectedAnswers"
                            class="screen__checkbox"
                            type="checkbox"
                            :value="answer"
                        />
                        <span class="checkmark"></span>
                        <p class="screen__answer paragraph-primary">{{ $t(answer) }}</p>
                    </label>
                </div>
            </div>

            <div class="screen__buttons">
                <button
                    class="screen__button btn btn-secondary"
                    type="button"
                    @click="handleBack"
                >
                    {{ $t('__quiz_button_back') }}
                </button>
                <button
                    class="screen__button btn btn-primary"
                    :class="{ 'screen__button--disabled': !isNextButtonActive }"
                    type="submit"
                    :disabled="!isNextButtonActive"
                >
                    {{ $t('__quiz_button_next') }}
                </button>
            </div>
        </form>
        <div class="screen__background">
            <img
                :src="questionIcon"
                alt=""
            />
        </div>
    </div>
</template>

<script>
import quizBlueLine from '../../assets/svg/quiz/quiz-blue-line.svg';
import questionIcon from '../../assets/svg/quiz/question.svg';

export default {
    props: {
        question: {
            type: String,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        answers: {
            type: Array,
            required: true,
        },
        initialAnswers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedAnswers: this.initialAnswers,
            quizBlueLine,
            questionIcon,
        };
    },
    computed: {
        isNextButtonActive() {
            return this.selectedAnswers.length > 0;
        },
    },
    methods: {
        handleSubmit() {
            this.$emit('next', this.selectedAnswers);
        },
        handleBack() {
            this.$emit('back');
        },
    },
};
</script>
